module.exports = __webpack_public_path__ + "img/american-express.bcb861b1.svg";